import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import AuthShell from './common/AuthShell';
import { Button, FormField } from './ui';

export default function ForgotPasswordRequest() {
  const [email, setEmail] = useState('');
  const [statusMessage, setStatusMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setStatusMessage('');
    setLoading(true);

    try {
      await api.post('/api/auth/forgot-password', { email });
      setStatusMessage(
        'If that email is registered, you will receive a password reset link shortly.'
      );
    } catch (err) {
      setError('Failed to send reset email. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset Your Password"
      subtitle="Enter your email address and we'll send you a link to reset your password."
    >
      {statusMessage && (
        <div className="mb-6 rounded-md border border-green-200 bg-green-50 p-4 text-sm text-green-800">
          <div className="font-semibold">Email Sent</div>
          <p className="mt-1">{statusMessage}</p>
        </div>
      )}

      {error && (
        <div className="mb-6 rounded-md border border-red-200 bg-red-50 p-4 text-sm text-red-800">
          <div className="font-semibold">Error</div>
          <p className="mt-1">{error}</p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-6">
        <FormField
          label="Email Address"
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@securethebag.ai"
          required
          autoComplete="email"
        />

        <Button type="submit" variant="primary" fullWidth disabled={loading} loading={loading}>
          {loading ? 'Sending' : 'Send Reset Link'}
        </Button>
      </form>

      <div className="mt-6 text-center">
        <Link
          to="/login"
          className="text-base sm:text-sm text-blue-700 hover:text-blue-800 transition-colors inline-flex items-center min-h-[44px] sm:min-h-0 font-medium"
        >
          ← Back to Login
        </Link>
      </div>
    </AuthShell>
  );
}
